const url = "https://www.emover24.com/wp-json/emover/v2";
export { url };
